import styled from 'styled-components';

export const RocketContainer = styled.div`
  position: fixed;
  right: 30px;
  z-index: 1000;
  pointer-events: none;
  transition: all 0.1s ease-out;

  @media (max-width: 768px) {
    right: 15px;
    transform: scale(0.8);
    opacity: 0.3;
  }

  @media (max-width: 480px) {
    right: 10px;
    transform: scale(0.6);
    opacity: 0.2;
  }
`;
